import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/entities')({
  staticData: { breadcrumb: 'Legal Entities', breadcrumbKey: 'K_BREADCRUMB_ENTITIES' },
});
